import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import analytics from "../../analytics";
import { withContext } from "../../context";
import { TEMPLATES } from "../../constants";
import PaymentWizard from "../../components/PaymentWizard";
import Cart from "./components/Cart";
import Categories from "./components/Categories";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Main from "./components/Main";
import ProductDetails from "./components/ProductDetails";
import Whatsapp from "./components/Whatsapp";

const useStyles = makeStyles(theme => ({
  shop: {
    marginRight: "200px",
    minHeight: "100vh"
  },
  container: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: theme.palette.background.default
  }
}));

const Home = ({ store, data, openPayment, onOpenPayment, onUpdateItems, onPaymentCompleted }) => {
  const classes = useStyles();

  const [currentCategory, setCurrentCategory] = useState({ view: 0, scrollTo: 0 });
  const [selectedProduct, setSelectProduct] = useState(null);
  const [searchProducts, setSearchProducts] = useState(null);

  const search = text => {
    const searchText = text.toLowerCase();

    if (searchText.length > 2) {
      const products = data.products.filter(p => p.name.toLowerCase().includes(searchText));

      setCurrentCategory({ view: 0, scrollTo: 0 });
      setSearchProducts([{ label: "Resultados de búsqueda", products }]);
    } else {
      setCurrentCategory({ view: 0, scrollTo: 0 });
      setSearchProducts(null);
    }
  };

  const selectCategory = (view, scrollTo) => {
    setCurrentCategory({ view, scrollTo });
  };

  const selectProduct = product => {
    if (product) {
      analytics.products([product.id], analytics.metrics.products.vista);
    }

    setSelectProduct(product);
  };

  return (
    <>
      <PaymentWizard
        template={TEMPLATES.ecommerce}
        items={data.items}
        total={data.totalPrice}
        open={openPayment}
        onClose={() => onOpenPayment(false)}
        onCompleted={onPaymentCompleted}
      />

      <ProductDetails
        product={selectedProduct}
        items={data.items}
        onChange={onUpdateItems}
        onClose={() => setSelectProduct(null)}
      />

      <div className={classes.shop}>
        <Header store={store} onSearchChange={search} />

        <div className={classes.container}>
          <Categories
            current={currentCategory.view}
            list={data.grouped}
            onSelect={index => selectCategory(currentCategory.view, index)}
          />

          <Main
            sections={searchProducts || data.grouped}
            scrollTo={currentCategory.scrollTo}
            onView={index => selectCategory(index, null)}
            onSelectProduct={selectProduct}
          />
        </div>

        <Footer store={store} />
      </div>

      <Cart
        items={data.items}
        total={data.totalPrice}
        onStartPaymentWizard={() => onOpenPayment(true)}
        onDeleteItem={(item, index) => onUpdateItems("delete", item, index)}
      />

      <Whatsapp store={store} />
    </>
  );
};

export default withContext(Home);
